import React from "react";
import "./CSS/ShopCategory.css";
import dropdown_icon from "../Components/Assets/dropdown_icon.png";
import Item from "../Components/Item/Item";
import { Link } from "react-router-dom";
// ✅ REAL TECH SERVICE DATA
const techServices = [
  {
    id: 1,
    name: "Website Development",
    image: require("../Components/Assets/tech expert.jpeg"),
    new_price: "From $500 - $10000 per/hr",
    // naira_price: "From ₦1,000,000 - #5,000,000",
    category: "tech",
  },
  {
    id: 2,
    name: "Mobile App Development",
    image: require("../Components/Assets/tech expert.jpeg"),
    new_price:  "From $500 - $10000 per/hr",
    // naira_price: "From ₦1,000,000 - #5,000,000",
    category: "tech",
  },
  {
    id: 3,
    name: "UI/UX Design",
    image: require("../Components/Assets/tech expert.jpeg"),
    new_price:  "From $100 - $2000 per/hr",
    // naira_price: "From ₦200,000 - #2,700,000",
    category: "tech",
  },
  {
    id: 4,
    name: "AI Automation",
    image: require("../Components/Assets/ai expert.jpeg"),
    new_price:  "From $50 - $2000 per/hr",
    // naira_price: "From ₦70,000 - #2,700,000",
    category: "ai",
  },
  {
    id: 5,
    name: "Chatbot Development",
    image: require("../Components/Assets/ai expert.jpeg"),
    new_price:  "From $500 - $10000 per/hr",
    // naira_price: "From ₦1,000,000 - #5,000,000",
    category: "ai",
  },
  {
    id: 6,
    name: "Video Production",
    image:  require("../Components/Assets/media expert.jpeg"),
    new_price:  "From $50 - $2000 per/hr",
    // naira_price: "From ₦70,000 - #2,700,000",
    category: "media",
  },
  {
    id: 7,
    name: "Content Creation",
    image:  require("../Components/Assets/production expert.jpeg"),
    new_price:  "From $20 - $2000 per/hr",
    // naira_price: "From ₦50,000 - #5,000,000",
    category: "media",
  },
  {
    id: 8,
    name: "Tech Tutorials & Training",
    image: require("../Components/Assets/tech expert.jpeg"),
    new_price:  "From $100 - $10000 per/hr",
    // naira_price: "From ₦200,000 - #5,000,000",
    category: "tutorials",
  },
    {
    id: 9,
    name: "E-Commerce Website",
    image: require("../Components/Assets/tech expert.jpeg"),
    new_price:  "From $500 - $10000 per/hr",
    // naira_price: "From ₦1,000,000 - #5,000,000",
    category: "tech",
  },
    {
    id: 10,
    name: "API Development",
    image: require("../Components/Assets/tech expert.jpeg"),
    new_price:  "From $500 - $10000 per/hr",
    // naira_price: "From ₦1,000,000 - #5,000,000",
    category: "tech",
  },
  {
    id: 11,
    name: "AI Automation",
    image: require("../Components/Assets/ai expert.jpeg"),
    new_price:  "From $500 - $10000 per/hr",
    // naira_price: "From ₦1,000,000 - #5,000,000",
    category: "ai",
  },
  {
    id: 12,
    name: "Chatbot Development",
    image: require("../Components/Assets/ai expert.jpeg"),
    new_price: "From $500 - $10000 per/hr",
    // naira_price: "From ₦1,000,000 - #5,000,000",
    category: "ai",
  },
    {
    id: 13,
    name: "Data Analysis & Insights",
    image: require("../Components/Assets/tech expert.jpeg"),
    new_price:  "From $200 - $10000 per/hr",
    // naira_price: "From ₦400,000 - #5,000,000",
    category: "ai",
  },
   {
    id: 14,
    name: "Video Production",
    image: require("../Components/Assets/production expert.jpeg"),
    new_price:  "From $50 - $10000 per/hr",
    // naira_price: "From ₦100,000 - #5,000,000",
    category: "media",
  },
  {
    id: 15,
    name: "Content Creation",
    image: require("../Components/Assets/content production expert.jpeg"),
    new_price:  "From $20 - $10000 per/hr",
    // naira_price: "From ₦50,000 - #5,000,000",
    category: "media",
  },
  {
    id: 16,
    name: "Social Media Management",
    image: require("../Components/Assets/content production expert.jpeg"),
    new_price:  "From $100 - $10000 per/hr",
    // naira_price: "From ₦200,000 - #5,000,000",
    category: "media",
  },
  {
    id: 17,
    name: "Branding & Graphics Design",
    image: require("../Components/Assets/content production expert.jpeg"),
    new_price:  "From $20 - $10000 per/hr",
    // naira_price: "From ₦70,000 - #5,000,000",
    category: "media",
  },

  // 🔹 TUTORIALS / TRAINING
  {
    id: 18,
    name: "Web Development Training",
    image: require("../Components/Assets/tech expert.jpeg"),
    new_price:  "From $200 - $10000 per/hr",
    // naira_price: "From ₦400,000 - #5,000,000",
    category: "tutorials",
  },
  {
    id: 19,
    name: "React & Frontend Mastery",
    image: require("../Components/Assets/tech expert.jpeg"),
    new_price:  "From $500 - $10000 per/hr",
    // naira_price: "From ₦1,000,000 - #5,000,000",
    category: "tutorials",
  },
  {
    id:20,
    name: "AI & Automation Training",
    image: require("../Components/Assets/ai expert.jpeg"),
    new_price:  "From $100 - $10000 per/hr",
    // naira_price: "From ₦200,000 - #5,000,000",
    category: "tutorials",
  },
  {
    id: 21,
    name: "Video Editing Masterclass",
    image: require("../Components/Assets/media expert.jpeg"),
    new_price:  "From $20 - $10000 per/hr",
    // naira_price: "From ₦50,000 - #5,000,000",
    category: "tutorials",
  },
];

const ShopCategory = (props) => {
  // ✅ FILTER BASED ON CATEGORY
  const filteredItems = techServices.filter(
    (item) => item.category === props.category
  );

  return (
    <div className="shopcategory">
      {/* BANNER */}
      <img src={props.banner} className="shopcategory-banner" alt="" />

      {/* TOP BAR */}
      <div className="shopcategory-indexSort">
        <p>
          <span>Showing 1 - {filteredItems.length}</span> out of{" "}
          {filteredItems.length} Services
        </p>

        <div className="shopcategory-sort">
          Sort by <img src={dropdown_icon} alt="" />
        </div>
      </div>

      {/* SERVICES GRID */}
      <div className="shopcategory-products">
        {filteredItems.map((item) => (
          <Item
            key={item.id}
            id={item.id}
            name={item.name}
            image={item.image}
            new_price={item.new_price}
            old_price={item.naira_price}
          />
        ))}
      </div>

      {/* LOAD MORE */}
      <div className="shopcategory-loadmore">
        <Link to="/" style={{ textDecoration: "none" }}>
          Explore More
        </Link>
      </div>
    </div>
  );
};

export default ShopCategory;